import JoinUsSectionBottomContent from "./bottom-content";
import JoinUsSectionTopContent from "./top-content";

const JoinUsSection = () => {
  return (
    <div>
      <JoinUsSectionTopContent />
      <JoinUsSectionBottomContent />
    </div>
  );
};

export default JoinUsSection;
